import { API } from '@Providers';
import type { Donation } from '../types';

export default async function (payload: Donation) {
  const endpoint = '/api/shelter/cart/donation';

  return API({ endpoint, method: 'put', payload });
}
